import { MENU_ELEMENT_ID } from '../common/constants';

export const handleLogoNav = () => {
  const $menu = document.getElementById(MENU_ELEMENT_ID);
  const $contextLogo = $menu?.querySelector('.tv2-menu__context-logo') as HTMLAnchorElement;
  $contextLogo?.addEventListener('click', (event) => {
    const currentUrl = window.location.href;
    const linkUrl = $contextLogo?.href;
    if (currentUrl === linkUrl) {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
    }
  });
  
};
